import axios from "axios";
import { useSetAtom } from "jotai";
import { LatestSession } from "../../@types/data";
import { useProfile } from "../../providers/profileProvider/ProfileProvider";
import { latestSessionAtom } from "../atoms/heartbeat.atom";
import { Heartbeat, HeartbeatResponse } from "../types/heartbeat.types";

export type GetLatestSessionResponse = {
  session: LatestSession;
};

const useHeartbeatStore = () => {
  const { token, isLoading } = useProfile();

  const setLatestSession = useSetAtom(latestSessionAtom);
  const axiosClient = axios.create({
    baseURL: process.env.NEXT_PUBLIC_PUNCH_CARD_URL
  });

  // token is sent here because the client doesn't refresh the token when it expires
  const sendHeartbeat = (body: Heartbeat) => {
    // Guard against calling API before authentication is ready
    if (isLoading || !token?.current) {
      throw new Error("Authentication not ready");
    }

    return axiosClient.post<HeartbeatResponse>("heartbeat", body, {
      headers: {
        Authorization: `Bearer ${token.current}`
      }
    });
  };

  const getLatestSession = async () => {
    // Guard against calling API before authentication is ready
    if (isLoading || !token?.current) {
      return;
    }

    const res = await axiosClient.get<GetLatestSessionResponse>(
      `/latest_session`,
      {
        headers: {
          Authorization: `Bearer ${token.current}`
        }
      }
    );
    setLatestSession(res.data.session);
  };

  return {
    sendHeartbeat,
    getLatestSession: getLatestSession
  };
};

export default useHeartbeatStore;
